export default __webpack_public_path__ + "static/bathroom@1x-d3a574b39cb384616bff9b9ae6d9b30b.jpg";